import { render } from "./CompanyList-All.vue?vue&type=template&id=056a10e8&ts=true"
import script from "./CompanyList-All.vue?vue&type=script&lang=ts"
export * from "./CompanyList-All.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__